/* src/app/components/Content/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

const Content = ({ children, classes, open, className }) => (
  <div
    className={classNames(
      classes.content,
      className,
      { [classes.contentShift]: open }
    )}
  >
    {children}
  </div>
);

Content.propTypes = {
  children: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

Content.defaultProps = {
  className: '',
};

export default withStyles(styles)(Content);



// WEBPACK FOOTER //
// ./src/app/components/Content/index.js